(function () {
    'use strict';

    angular.module('app').controller('WaypointDetailsController', WaypointDetailsController);

    WaypointDetailsController.$inject = [
        'FleetService',
        '$rootScope',
        '$uibModal',
        '$uibModalInstance',
        '$q',
        'toastr',
        'waypoint',
        'route',
        '$timeout',
        'center',
        'ConfirmationModalFactory'
    ];

    function WaypointDetailsController(
        FleetService,
        $rootScope,
        $uibModal,
        $uibModalInstance,
        $q,
        toastr,
        waypoint,
        route,
        $timeout,
        center,
        ConfirmationModalFactory
    ) {
        let vm = this;
        vm.waypoint = angular.copy(waypoint);
        vm.waypointRaw = angular.copy(vm.waypoint);
        vm.resetMap = resetMap;
        vm.showWaypoints = showWaypoints;
        vm.showRoute = showRoute;
        vm.save = save;
        vm.close = close;
        vm.enabledMarker = 'https://raw.githubusercontent.com/Concept211/Google-Maps-Markers/master/images/marker_red.png';
        vm.disabledMarker = 'https://raw.githubusercontent.com/Concept211/Google-Maps-Markers/master/images/marker_grey.png';
        vm.changeStatus = changeStatus;

        const {latitude, longitude} = angular.extend(center || {}, angular.copy(vm.waypoint) || {});

        const toInActiveConf = new ConfirmationModalFactory({}, {
            message: 'messages.warning.statusChange.MESSAGE.TO_WAYPOINT_INACTIVE',
            code: 'messages.warning.statusChange.CODE'
        });

        const toActiveConf = new ConfirmationModalFactory({}, {
            message: 'messages.warning.statusChange.MESSAGE.TO_WAYPOINT_ACTIVE',
            code: 'messages.warning.statusChange.CODE'
        });

        vm.mapData = {
            config: {
                mapId: 'waypointMap',
                resetView: true,
                zoom: 16,
                enableDefaultUI: true
            },
            mapControls: [],
            locationData: [],
            mapCenter: {
                position: {lat: latitude, lng: longitude},
                icon: '',
            },
            centerAddress: latitude && longitude ? null : getUserOfficeAdd(),
            onMapClick: function (map, e) {
                /*if (vm.mapData.markers.length) {
                    removeMarkers();
                } else {
                    setMarkers(map, e);
                }*/
            },
            onMapMount: () => {
                if(!vm.waypoint){
                    showWaypoints({
                        zoomToMarkers: true
                    });
                    showRoute();

                    return false;
                }

                vm.mapData.map.addListener('center_changed', () => {
                    $timeout(() => {
                        const latLng = vm.mapData.map.getCenter();
                        vm.waypoint.latitude = latLng.lat();
                        vm.waypoint.longitude = latLng.lng();
                    });
                });
            },
            loading: false
        };

        function setMarkers(map, e) {
            vm.mapData.markers.push(
                new google.maps.Marker({
                    position: e.position || e.latLng,
                    map: map
                })
            );
        }

        function showRoute() {
            if(vm.routeDrawn){
                vm.routeDrawn.setMap(null);
                vm.routeDrawn = null;
                return false;
            }
            vm.fetchingRoute = true;
            FleetService.Routes.getMapRoute(route => {
                if(!route.routes[0]){
                    toastr.error('No land route generated from waypoints');
                    return false;
                }
                const decoded = google.maps.geometry.encoding.decodePath(route.routes[0].overviewPolyline.encodedPath);
                vm.routeDrawn = new google.maps.Polyline({
                    path: decoded,
                    strokeColor: '#ef2139',
                    strokeOpacity: 1.0,
                    strokeWeight: 4,
                    zIndex: 3
                });
                vm.routeDrawn.setMap(vm.mapData.map);
                vm.fetchingRoute = false;
            }, err => {
                toastr.error('Unable to load route', err.message);
                vm.fetchingRoute = false;
            }, {
                'routeId': route.id
            });
        }

        function showWaypoints(opts) {
            vm.waypointsVisible = !vm.waypointsVisible;
            vm.fetchingWaypoints = true;
            if (vm.waypointsVisible) {
                FleetService.Routes.getWaypoints(route.id, data => {
                    angular.forEach(data.content, function (w) {
                        if (!waypoint || w.id !== waypoint.id) {
                            const {latitude, longitude} = w;
                            setMarkers(vm.mapData.map, {
                                position: {
                                    lat: latitude,
                                    lng: longitude
                                }
                            });
                        }
                    });

                    if(opts && opts.zoomToMarkers){
                        zoomToMarkers(vm.mapData.map, vm.mapData.markers);
                    }
                    vm.fetchingWaypoints = false;
                }, error => {
                    toastr.error('Unable to get waypoints', error.message);
                    vm.waypointsVisible = false;
                    vm.fetchingWaypoints = false;
                }, {
                    active: true,
                    size: 20
                });
            } else {
                removeMarkers();
                vm.fetchingWaypoints = false;
            }
        }

        function zoomToMarkers(map, markers) {
            let bounds = new google.maps.LatLngBounds();
            let points = markers;
            for (let n = 0; n < points.length; n++) {
                bounds.extend(points[n].position);
            }
            map.fitBounds(bounds);
        }

        function removeMarkers() {
            vm.mapData.markers.map(marker => {
                marker.setMap(null);
            });
            vm.mapData.markers = [];
            vm.mapData.markerCluster.clearMarkers();
        }

        function resetMap() {
            const {latitude, longitude} = vm.waypointRaw;
            vm.mapData.resetCenter();
            removeMarkers();
            if (latitude && longitude) {
                /*setMarkers(vm.mapData.map, {
                    position: {
                        lat: latitude,
                        lng: longitude
                    }
                });*/
                angular.extend(vm.waypoint, {
                    latitude,
                    longitude
                });
            }
        }

        function cleanPayload(waypoint) {
            const {waypointId, name, type, longitude, latitude, active} = waypoint;
            return {waypointId, name, type: 'node', longitude, latitude, active, routeId: route.id}
        }

        function save(form) {

            if (form.$invalid) {
                return false;
            }
            vm.saving = true;
            if (!waypoint.id) {
                FleetService.Waypoints.create(cleanPayload(vm.waypoint), data => {
                    vm.saving = false;
                    $uibModalInstance.close('');
                }, err => {
                    if(err.code.toString() === '400') toastr.info(err.message);
                    else toastr.error(err.message);
                    vm.saving = false;
                });
            } else {
                FleetService.Waypoints.update(waypoint.id, cleanPayload(vm.waypoint), data => {
                    $uibModalInstance.close('');
                    vm.saving = false;
                }, err => {
                    if(err.code.toString() === '400') toastr.info(err.message);
                    else toastr.error(err.message);
                    vm.saving = false;
                });
            }
        }

        function close() {
            $uibModalInstance.dismiss('');
        }

        function getUserOfficeAdd() {
            const userOffice = $rootScope.GlobalProfile.office;
            const userOfficeLocation = $rootScope.GlobalProfile.office.location;
            return `${userOffice.addressLine1 || ''} ${userOffice.addressLine2 || ''} ${userOfficeLocation.code} ${angular.getObjVal(userOfficeLocation, 'state.name')} ${userOfficeLocation.country.name}`;
        }

        function changeStatus(event){
            event.preventDefault();
            if(vm.waypoint.active) {
                vm.waypoint.active = false;
                toActiveConf.getInstance().result.then(cond=>{
                    if(cond) {
                        vm.waypoint.active = true;
                    }
                })
            } else {
                vm.waypoint.active = true;
                toInActiveConf.getInstance().result.then(cond=>{
                    if(cond) {
                        vm.waypoint.active = false;
                    }
                });
            }
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/fleets/modals/WaypointDetailsController.js